import { DocumentPreview } from "@screencloud/screencloud-ui-components";
import { MediaType } from "src/constants/constants";
import { DocumentFrame, ViewerAudio, ViewerImage, ViewerVideo } from "./styles";
import { FileViewerSource } from "./utils/getFileViewerSource";

export interface FileViewerProps {
  source: FileViewerSource;
  title?: string;
  /** Called when the browser cannot load the media. */
  onError?: () => void;
}

/** View-only rendering of an image, video, audio or document file. */
export const FileViewer = ({ source, title, onError }: FileViewerProps) => {
  switch (source.kind) {
    case MediaType.VIDEO:
      return (
        <ViewerVideo
          data-testid="file-viewer-video"
          src={source.src}
          controls
          autoPlay
          muted
          onError={onError}
        />
      );
    case MediaType.AUDIO:
      return (
        <ViewerAudio
          data-testid="file-viewer-audio"
          src={source.src}
          controls
          onError={onError}
        />
      );
    case MediaType.DOCUMENT:
      return (
        <DocumentFrame data-testid="file-viewer-document">
          {/* DocumentPreview lays out children marked with className "document". */}
          <DocumentPreview images={source.pages}>
            {source.pages.map((page, index) => (
              <div className="document" key={page}>
                <img src={page} alt={`${title ?? ""} ${index + 1}`.trim()} />
              </div>
            ))}
          </DocumentPreview>
        </DocumentFrame>
      );
    default:
      return (
        <ViewerImage
          data-testid="file-viewer-image"
          src={source.src}
          alt={title ?? ""}
          onError={onError}
        />
      );
  }
};
